import type { PAGE_POSITIONS } from 'types';

import gtm from '~/services/gtm.client';
import { getPreviousPagePosition } from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
};

class SearchInputClickEvent extends UserEvent<EventData> {
  sendToGtm() {
    if (this.data.isBot) return;

    const page_position: PAGE_POSITIONS = 'Header';

    gtm.pushToDataLayer({
      event: 'search_input_click',
      page_position,
      previous_page_position: getPreviousPagePosition()
    });
  }
}

export default SearchInputClickEvent;
